import React from 'react';
import { useLanguage } from '@/App';
import { Megaphone, Camera } from 'lucide-react';
import SpacedText from '@/components/SpacedText';
import { ScrollReveal } from '@/components/ScrollReveal';

const Services = () => {
  const { language } = useLanguage();

  const content = {
    tr: {
      title: 'Hizmetlerimiz',
      subtitle: 'Influencer pazarlamanın her adımını tek çatı altında, profesyonelce yönetiyoruz.',
      service1: 'Influencer Pazarlama',
      service1Desc: 'Geniş veri tabanımızdan, markaların stratejilerine ve bütçelerine en uygun influencer\'ları öneriyoruz.\n\nHangi influencer\'lar seçilmeli ve kampanya sonucunda kazanımlar ne olur (reel izlenme, link tıklama vb.) — veriye dayalı projeksiyonlarımızı kampanya başlamadan markalarla paylaşıyoruz.\n\nKampanya başladıktan sonra ise tüm süreci adil, şeffaf ve profesyonelce yönetiyoruz.',
      service2: 'İçerik Üretimi & Prodüksiyon',
      service2Desc: 'Kampanyalar veya markaların kendi sosyal medya kanalları için proje bazlı video içerikleri üretiyoruz.\n\nTüm prodüksiyon sürecini kendi ekibimizle gerçekleştiriyoruz.\n\nBöylelikle hem kaliteden ödün vermiyoruz hem de maliyetleri makul tutabiliyoruz.',
      bottomText: 'Amacımız basit: Influencer pazarlamayı tahmine değil veriye dayalı bir kanala dönüştürmek.'
    },
    en: {
      title: 'Our Services',
      subtitle: 'We professionally manage every step of influencer marketing under one roof.',
      service1: 'Influencer Campaign Management',
      service1Desc: 'From our extensive database, we recommend influencers that best fit brands\' strategies and budgets.\n\nWhich influencers should be selected and what will be the campaign outcomes (reel views, link clicks, etc.) — we share our data-driven projections with brands before the campaign starts.\n\nOnce the campaign starts, we manage the entire process fairly, transparently, and professionally.',
      service2: 'Content Production & Production',
      service2Desc: 'We produce project-based video content for campaigns or brands\' own social media channels.\n\nWe carry out the entire production process with our own team.\n\nThis way, we don\'t compromise on quality and can keep costs reasonable.',
      bottomText: 'Our goal is simple: To transform influencer marketing from a guesswork-based channel to a data-driven one.'
    }
  };

  const t = content[language];

  const services = [
    { icon: Megaphone, title: t.service1, desc: t.service1Desc },
    { icon: Camera, title: t.service2, desc: t.service2Desc }
  ];

  return (
    <section id="services" className="py-12 bg-black bg-opacity-75 border-t border-gray-800" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-6 md:mb-8">
            <SpacedText 
              text={t.title} 
              className="text-2xl md:text-4xl text-[#FFDD59] mb-3 md:mb-4"
            />
            <p className="text-sm md:text-lg text-white leading-relaxed max-w-4xl mx-auto mt-3 md:mt-4 px-2">
              {t.subtitle}
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 max-w-4xl mx-auto">
          {/* Service 1 - Influencer Pazarlama */}
          <ScrollReveal delay={0}>
            <div 
              className="bg-gray-900 border border-gray-700 rounded-xl p-4 md:p-6 hover:border-[#FFDD59] transition-colors duration-300 card-hover-glow h-full"
              data-testid="service-card-0"
            >
              <Megaphone className="mb-3 md:mb-4" size={36} color="#FFDD59" />
              <h3 className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-3">
                {t.service1}
              </h3>
              <div className="text-gray-300 text-xs md:text-sm leading-relaxed space-y-2 md:space-y-3">
                {t.service1Desc.split('\n\n').map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>
            </div>
          </ScrollReveal>

          {/* Service 2 - İçerik Üretimi */}
          <ScrollReveal delay={150}>
            <div 
              className="bg-gray-900 border border-gray-700 rounded-xl p-4 md:p-6 hover:border-[#FFDD59] transition-colors duration-300 card-hover-glow h-full"
              data-testid="service-card-1"
            >
              <Camera className="mb-3 md:mb-4" size={36} color="#FFDD59" />
              <h3 className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-3">
                {t.service2}
              </h3>
              <div className="text-gray-300 text-xs md:text-sm leading-relaxed space-y-2 md:space-y-3">
                {t.service2Desc.split('\n\n').map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Bottom Text */}
        <ScrollReveal delay={300}>
          <div className="max-w-4xl mx-auto mt-6 md:mt-10 text-center px-2">
            <p className="text-sm md:text-lg text-[#FFDD59] font-semibold leading-relaxed">
              {t.bottomText}
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Services;
